module.exports = __webpack_public_path__ + "static/city_step04-de5d777d6f5b53dbc065edf2b1048cc0.png";